import type { MeetingTemplateKind } from '@wundo/shared/meetingTemplate.ts';

interface RowPlace {
  name: string;
  position: number;
  total: number;
}

export interface MeetingTemplateListLabels {
  newTemplate: string;
  /** On a default row that does not say its kind. */
  defaultMarker: string;
  /** On a row only its maker sees. */
  personalMarker: string;
  /** On a default row that says its kind: a default is per kind. */
  defaultMarkers: Record<MeetingTemplateKind, string>;
  /** The note on a row for anything but a 1:1, which is what most types are. */
  kinds: Record<MeetingTemplateKind, string>;
  makeDefault: string;
  /** Names the menu that holds a row's less common actions. */
  rowActions: (params: { name: string }) => string;
  /** Names the grip a row is dragged by. */
  move: (params: { name: string }) => string;
  dragInstructions: string;
  dragStart: (params: RowPlace) => string;
  /** Also what a keyboard move announces. */
  dragOver: (params: RowPlace) => string;
  dragEnd: (params: RowPlace) => string;
  dragCancel: (params: { name: string }) => string;
}

export const DEFAULT_MEETING_TEMPLATE_LIST_LABELS: MeetingTemplateListLabels = {
  newTemplate: 'New template',
  defaultMarker: 'Default for 1:1',
  personalMarker: 'Personal',
  defaultMarkers: {
    one_on_one: 'Default for 1:1',
    team: 'Default for team meetings',
    other: 'Default for other meetings',
  },
  kinds: {
    one_on_one: '1:1',
    team: 'Team meeting',
    other: 'Other',
  },
  makeDefault: 'Make default',
  rowActions: ({ name }) => `Actions for ${name}`,
  move: ({ name }) => `Move ${name}`,
  dragInstructions: 'Use the up and down arrows to move this template.',
  dragStart: ({ name, position, total }) =>
    `${name} picked up. Position ${position} of ${total}.`,
  dragOver: ({ name, position, total }) =>
    `${name} is now in position ${position} of ${total}.`,
  dragEnd: ({ name, position, total }) =>
    `${name} dropped in position ${position} of ${total}.`,
  dragCancel: ({ name }) => `Move of ${name} cancelled.`,
};
